import { AnyAction, Reducer, combineReducers } from "redux";
import { CustomerPortalState } from ".";
import { AUTH_ACTIONS } from "../../../types/redux";
import assetReducer from "./reducers/assetReducer";
import authReducer from "./reducers/authReducer";
import companyReducer from "./reducers/companyReducer";
import contentChannelReducer from "./reducers/contentChannelReducer";
import customizationReducer from "./reducers/customizationReducer";
import frontlayerConfigReducer from "./reducers/frontlayerConfigReducer";
import notificationReducer from "./reducers/notificationReducer";
import organizationUnitReducer from "./reducers/organizationUnitReducer";
import screenReducer from "./reducers/screenReducer";
import userReducer from "./reducers/userReducer";
import workspaceReducer from "./reducers/workspaceReducer";
import dailyContentPlaylistReducer from "./reducers/dailyContentPlaylistReducer";
import promotionReducer from "./reducers/promotionReducer";
import cmsReducer from "./reducers/cmsReducer";
import offeringsReducer from "./reducers/offeringsReducer";
import customerSetupReducer from "./reducers/customerSetupReducer";
import signagePlaylistReducer from "./reducers/signagePlaylistReducer";
import { groupReducer } from "./reducers/groupReducer";

const reducer: Reducer<CustomerPortalState, AnyAction> = (
  state: CustomerPortalState | undefined,
  action: AnyAction
) => {
  const appReducer = combineReducers({
    auth: authReducer,
    workspace: workspaceReducer,
    customization: customizationReducer,
    organizationUnits: organizationUnitReducer,
    notification: notificationReducer,
    user: userReducer,
    company: companyReducer,
    screen: screenReducer,
    contentChannel: contentChannelReducer,
    asset: assetReducer,
    dailyContentPlaylist: dailyContentPlaylistReducer,
    frontlayerConfig: frontlayerConfigReducer,
    promotion: promotionReducer,
    CMS: cmsReducer,
    offerings: offeringsReducer,
    customerSetup: customerSetupReducer,
    digitalSignagePlaylists: signagePlaylistReducer,
    group: groupReducer,
  });

  if (action.type === AUTH_ACTIONS.SET_LOGOUT) {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default reducer;
